import React from 'react';
import PropTypes from 'prop-types';
import { StatusIcon } from '@saucelabs/ds-status';

const RootCauseBannerV2 = ({
  onButtonClick,
}) => (
  <div className="flex items-center bg-red-50 text-sm leading-loose pt-0.5 pr-2 pb-0.5 pl-2 border-solid border-red-900 border-t-0 border-r-0 border-b-0 border-l-4">
    <StatusIcon type="failed" />
    <div className="ml-2 font-semibold">Failure pattern detected</div>
    <a
      className="text-red-900 ml-auto cursor-pointer"
      onClick={onButtonClick}
      role="button"
      tabIndex="0"
    >
      View Analysis
    </a>
  </div>
);

RootCauseBannerV2.propTypes = {
  onButtonClick: PropTypes.func.isRequired,
};

export default RootCauseBannerV2;
